export const ACCESS_TOKEN_KEY = 'a_T_c';
export const REFRESH_TOKEN_KEY = 'r_T_c';
export const TRANSACTION_INTERMEDARY_KEY = 'T_H_C';
